import { render, staticRenderFns } from "./ModalImgSet.vue?vue&type=template&id=000aff05&scoped=true&"
import script from "./ModalImgSet.vue?vue&type=script&lang=js&"
export * from "./ModalImgSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000aff05",
  null
  
)

export default component.exports